import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import withMobileDialog from "@material-ui/core/withMobileDialog";

import { EmptyRecord } from "../../utils/PageUtility";
import RecordPagination from "../../utils/RecordsPagination";
import Approve from "@material-ui/icons/DoneOutline";
import Decline from "@material-ui/icons/Close";
import moment from "moment";

import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";
import { appHelpers } from "../../_helpers";
//import Button from "components/CustomButtons/Button.jsx";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
    icon: {
      margin: "8px 0px 8px 8px",
      position: "relative",
      top: "7px",
      paddingLeft: "8px",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Poppins', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
        color: "#777",
        fontSize: "65%",
        fontWeight: "400",
        lineHeight: "1",
    }
    },
    tableStyle: {
        padding: 0
    },
    tableHeader: {
        color: "#04137b",
    }
};

const SettingTableStructure = ({
  classes,
  currentPage,
  pageSize,
  pageIndex,
  handleApprove,
  handleReject,
  records,
  filterUsers,
  user,
  handleEdit,
  handleApproveThreshold,
  filterAirlines,
}) => (
  <Table className={classes.table} aria-labelledby="tableTitle">
    <TableHead className={classes.negativeColor} color="primary">
      <TableRow>
        <TableCell className={classes.tableHeader}  padding="none">S/N</TableCell>
        <TableCell className={classes.tableHeader}  padding="none">Date</TableCell>
        <TableCell className={classes.tableHeader}  padding="none">Exchange Rate</TableCell>
        <TableCell className={classes.tableHeader}  padding="none">Created By</TableCell>
        <TableCell className={classes.tableHeader}  padding="none">Created Date</TableCell>
        <TableCell className={classes.tableHeader}  padding="none">Action</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {records &&
        records.map((item, key) => {
          return (
            <TableRow hover key={key}>
              <TableCell>{pageIndex + key}</TableCell>
              <TableCell padding="none" component="th">
                {moment(item.EffectiveDate).format("YYYY-MM-DD")}
              </TableCell>
              <TableCell padding="none" component="th">
                &#8358; {appHelpers.numberWithCommas(item.Rate)}
              </TableCell>
              <TableCell padding="none">
                {item.CreatedBy ? filterUsers(item.CreatedBy) : "N/A"}
              </TableCell>
              <TableCell padding="none" component="th">
                {moment(item.CreatedDate).format("YYYY-MM-DD")}
              </TableCell>

              <TableCell padding="none" component="th">
                {item.CreatedBy !== user.userId ? (
                  <span>
                    <span
                      onClick={() => handleApprove(1, item.Id)}
                      style={{ cursor: "pointer", color: "#66bb6a" }}
                      autoFocus
                    >
                      <span
                        style={{
                          margin: "8px 0px 8px 8px",
                          position: "relative",
                          top: "7px",
                          paddingLeft: "8px",
                        }}
                      >
                        <Approve />{" "}
                      </span>
                      Approve
                    </span>
                    <span
                      onClick={() => handleReject(0, item.Id)}
                      style={{ cursor: "pointer", color: "#dd2735" }}
                    >
                      <span
                        style={{
                          margin: "8px 0px 8px 8px",
                          position: "relative",
                          top: "7px",
                          paddingLeft: "8px",
                        }}
                      >
                        <Decline />{" "}
                      </span>
                      Reject
                    </span>
                  </span>
                ) : (
                  <span style={{ color: "#828282" }}>Pending</span>
                )}
              </TableCell>
            </TableRow>
          );
        })}
    </TableBody>
  </Table>
);

class AllPscTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      flight: false,
    };
  }

  handleClickOpen = (flight) => {
    this.setState({ open: true });
    this.setState({ flight });
    this.props.fetchFlightPassengers(flight.Id);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const {
      classes,
      totalCounts,
      handleApprove,
      handleEdit,
      handleReject,
      handleApproveThreshold,
      filterUsers,
      fetchRecords,
      currentPage,
      pageSize,
      user,
      records,
      filterAirlines,
    } = this.props;
    if (totalCounts === 0)
      return <EmptyRecord message={"No pending Exchange Rate yet!"} />;

    const pageIndex = pageSize * (currentPage - 1) + 1;

    return (
      <div>
        {this.props.records && (
          <div
            className={classes.tableResponsive}
            style={{ overflowX: "auto" }}
          >
            <RecordPagination
              fetchMore={fetchRecords}
              totalCount={totalCounts}
              pageSize={pageSize}
              currentPage={currentPage}
              target={
                <SettingTableStructure
                  pageIndex={pageIndex}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  handleApprove={handleApprove}
                  handleReject={handleReject}
                  records={records}
                  classes={classes}
                  filterUsers={filterUsers}
                  handleEdit={handleEdit}
                  handleApproveThreshold={handleApproveThreshold}
                  user={user}
                  filterAirlines={filterAirlines}
                />
              }
            />
          </div>
        )}
      </div>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(AllPscTable));



// WEBPACK FOOTER //
// ./src/Regional-Views/ExchangeRate/allCharges.js